export default "__VITE_ASSET__KI3RpW7J__"